<template>
  <v-window v-model="winIndex">
    <v-window-item :value="1">
      <v-card>
        <message :messages="messages"></message>
        <v-layout row wrap v-if="!clmNo">
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex xs12 sm4>
                            <v-text-field v-model="filters.clmNo" :label="labels.clmNo" />
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-text-field v-model="filters.xol" :label="labels.xol" />
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-text-field v-model="filters.docNo" :label="labels.docNo" />
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              :server-items-length="totalItems"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="key"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.clmNo }}</td>
                  <td>{{ row.item.riType }}</td>
                  <td>{{ row.item.xol }}</td>
                  <td>{{ row.item.tranType }}</td>
                  <td>{{ row.item.docNo }}</td>
                  <td>{{ row.item.curr }}</td>
                  <td class="text-right">{{ formatDisplayNumber(row.item.rcvyAmt) }}</td>
                  <td class="text-right">{{ formatDisplayNumber(row.item.rcvyAmtLoc) }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)" :review="canReview(row.item)" @review="doReview(row.item)" />
                  </td></tr
              ></template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-window-item>
    <v-window-item :value="2">
      <X-O-L-Recovery-Detail @close="winIndex = 1" :mode="mode" ref="xoldetail" :refresh="refresh" />
    </v-window-item>
  </v-window>
</template>

<script>
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import { formatDisplayNumber } from '@/utils/number'
import { XOL_RECOVERY_SELECT } from '@/store/types'
import XOLRecoveryDetail from '@/components/core/claimManagement/xolRecovery/XOLRecoveryDetail'

export default {
  components: {
    XOLRecoveryDetail
  },
  props: {
    clmNo: {
      type: String,
      default: undefined
    },
    allowReview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      winIndex: 1,
      mode: 'list',
      refresh: 0,
      labels: {
        clmNo: 'Claim No.',
        xol: 'XOL',
        docNo: 'Document No.'
      },
      filters: {
        clmNo: undefined,
        xol: undefined,
        docNo: undefined
      },
      headers: [
        { text: 'Claim No.', value: 'clmNo' },
        { text: 'RI Type', value: 'riType' },
        { text: 'XOL', value: 'xol' },
        { text: 'Tran Type', value: 'tranType' },
        { text: 'Doc No.', value: 'docNo' },
        { text: 'Curr', value: 'curr' },
        { text: 'Amt To Be Recovered', value: 'rcvyAmt' },
        { text: 'Amt To Be Recovered (Local)', value: 'rcvyAmtLoc' },
        TableConst.tableActionHeader
      ],
      items: [],
      pagination: {
        sortDesc: [true],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async doInit() {
      if (this.xolRecovery.init !== 1) {
        await Promise.all([this.$store.dispatch('xolRecoveryInit')])
      }
      this.resetMessages()
      this.fetchData()
    },
    canReview(data) {
      if (!this.allowReview) {
        return false
      }
      if (data.tranRel) {
        return false
      }
      return true
    },
    async doReview(data) {
      this.resetMessages()
      this.$store.commit(XOL_RECOVERY_SELECT, data)
      this.winIndex = 2
      this.mode = 'review'
      this.refresh++
    },
    async doQuery(data) {
      this.resetMessages()
      this.$store.commit(XOL_RECOVERY_SELECT, data)
      this.winIndex = 2
      this.mode = 'query'
      this.refresh++
    },
    formatDisplayNumber(value, scale) {
      return formatDisplayNumber(value, scale)
    },
    async fetchData() {
      const apiUrl = this.menu.xolRecoveryList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            clmNo: this.clmNo,
            page: page - 1,
            size: itemsPerPage
          }
          if (this.clmNo) {
            this.filters.clmNo = this.clmNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = data
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.clmNo = undefined
      this.filters.xol = undefined
      this.filters.docNo = undefined
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      // Reset to page 1
      this.pagination.page = 1
      this.fetchData()
    }
  },
  mounted() {
    this.doInit()
  },
  created() {},
  computed: {
    xolRecovery() {
      return this.$store.state.xolRecovery
    },
    menu() {
      return this.xolRecovery.menu
    }
  },
  mixins: [listMixin]
}
</script>

<style lang="scss">
</style>
